module.exports = __webpack_public_path__ + "img/1523.ca15475b.gif";